/**
 * ชุดอวตารสำเร็จรูป — **แหล่งเดียว** ทั้งหน้าเลือกโปรไฟล์และหน้าผู้ปกครอง
 *
 * ⚠️ คีย์ต้องตรงกับ `AVATAR_KEYS` ใน `backend/app/schemas/learner.py`
 *   ถ้าไม่ตรง ผู้ใช้จะเลือกได้แต่เซิร์ฟเวอร์ปฏิเสธด้วย 422 ซึ่งดูเหมือนแอปพัง
 *
 * ⚠️ PDPA — ไม่มีการอัปโหลดรูป เพราะรูปเด็กคือข้อมูลที่ CLAUDE.md ข้อ 8 ห้ามเก็บ
 */
export const AVATARS: Record<string, string> = {
  fox: '🦊',
  cat: '🐱',
  owl: '🦉',
  panda: '🐼',
  rabbit: '🐰',
  dino: '🦕',
  robot: '🤖',
  koala: '🐨',
  penguin: '🐧',
  tiger: '🐯',
}
